import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function WebsiteAppIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="WebsiteApp">
          <path
              fillRule="evenodd"
              d="M11.75 21.034a9.284 9.284 0 1 0 0-18.568 9.284 9.284 0 0 0 0 18.568Zm0 1.466c5.937 0 10.75-4.813 10.75-10.75S17.687 1 11.75 1 1 5.813 1 11.75 5.813 22.5 11.75 22.5Z"
              clipRule="evenodd"
          />
          <path
              fillRule="evenodd"
              d="M11.75 5.765c-1.19 0-2.081.889-2.081 2.14 0 1.25.892 2.14 2.081 2.14 1.19 0 2.081-.89 2.081-2.14 0-1.08-.925-2.14-2.08-2.14Zm-3.547 2.14c0-2.032 1.52-3.606 3.547-3.606 2.06 0 3.547 1.813 3.547 3.606 0 2.032-1.52 3.605-3.547 3.605S8.203 9.937 8.203 7.905ZM10.035 13.445c-1.214 0-2.35 1.138-2.35 2.413v.575c0 .291.07.466.158.585.093.127.257.258.555.374.628.246 1.634.344 3.087.344h.53c1.453 0 2.46-.098 3.087-.344.298-.116.462-.247.555-.373.088-.12.157-.295.157-.586v-.575c0-1.275-1.135-2.413-2.349-2.413h-3.43ZM6.22 15.858c0-2.056 1.763-3.88 3.815-3.88h3.43c2.052 0 3.815 1.824 3.815 3.88v.575c0 .541-.135 1.037-.443 1.455-.304.412-.729.685-1.201.87-.913.356-2.173.444-3.62.444h-.531c-1.448 0-2.708-.088-3.62-.444-.473-.184-.898-.458-1.202-.87-.308-.418-.443-.914-.443-1.455v-.575Z"
              clipRule="evenodd"
          />
      </SvgIcon>
  );
}
